import { CoreUiException } from "./core-ui-exception";

/**
 * The event action is invalid
 */
export class InvalidEventActionException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("InvalidActionException", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, InvalidEventActionException.prototype);
    }
}
